import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-project-member-batch-invitation-form', {
  mixins: [eventListenerMixin],

  connected() {
    this.fieldsWrapper = this.querySelector('.email-fields-wrapper');

    this.listenTo(this.querySelector('.link-add'), {
      click: this.handleLinkAddClick.bind(this),
    });
    this.listenTo(this.fieldsWrapper, 'click', this.handleLinkRemoveClick.bind(this));
  },

  disconnected() {
    this.stopListening();
  },

  handleLinkAddClick() {
    const field = this.fieldsWrapper.querySelector('.tr-form-input:last-child').cloneNode(true);
    const input = field.querySelector('.mdc-text-field input');

    input.name = input.name.replace(/\[(\d+)\]/, (s, p1) => `[${parseInt(p1, 10) + 1}]`);
    if (!field.querySelector('.link-remove')) {
      field.insertAdjacentHTML('beforeend', this.generateRemoveLink());
    }

    this.fieldsWrapper.insertAdjacentElement('beforeend', field);
  },

  handleLinkRemoveClick(event) {
    const link = closest(event.target, '.link-remove');
    if (link) {
      const field = closest(event.target, '.tr-form-input');
      if (field) this.fieldsWrapper.removeChild(field);
    }
  },

  generateRemoveLink() {
    return '<a href="javascript:;" class="link-remove"><i class="twr twr-times"></i></a>';
  },
});
